// extracted by mini-css-extract-plugin
export var bookingWrapper = "ContactForm-module--bookingWrapper--2ipmo";
export var bookingText = "ContactForm-module--bookingText--3SWmu";
export var formWrapper = "ContactForm-module--formWrapper--yis9h";
export var submitButton = "ContactForm-module--submitButton--1vRyO";
export var contactUs = "ContactForm-module--contactUs--2JAcO";
export var or = "ContactForm-module--or--3QhPv";
export var emailUs = "ContactForm-module--emailUs--fxeOA";
export var emailAddress = "ContactForm-module--emailAddress--26uxl";
export var formGrid = "ContactForm-module--formGrid--2J1Uo";